var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import UcWindow from "../../../lib/UcWindow";
import ExprInput from "../../../lib/builtin/designerComponents/ExprInput";
import ReportDimItem from './ReportDimItem';
import { isEqual, cloneDeep } from "lodash-es";
import { getPopupPosition } from "../../../lib/utils/styling";
import debounce from "lodash-es/debounce";
const MAX_DIMENSION_COUNT = 10;
// d1, d2, d3 ...
const getDefaultDs = () => [...Array(MAX_DIMENSION_COUNT)].map((_, index) => `d${index + 1}`);
let ReportDimsToolbarWidget = class ReportDimsToolbarWidget extends Vue {
  constructor() {
    super(...arguments);
    this.left = '50%';
    this.top = '25px';
    this.minWidth = 570;
    this.maxWidth = 710;
    this.shown = false;
    this.allDimensions = getDefaultDs();
    this.dimensionDisabled = true;
    this.changeValidate = debounce(() => {
      this.validate();
    }, 200);
    this.validateStatus = [];
    this.oldReportDimensions = [];
  }
  get width() {
    return `${this.dimensionDisabled ? this.minWidth : this.maxWidth}px`;
  }
  get reportDimensions() {
    var _this$designer$rootPa;
    return ((_this$designer$rootPa = this.designer.rootPagelet) === null || _this$designer$rootPa === void 0 ? void 0 : _this$designer$rootPa.reportDimensions) || [];
  }
  get dimensions() {
    const used = this.reportDimensions.map(({
      dimension
    }) => dimension);
    return this.allDimensions.filter(d => !used.includes(d));
  }
  created() {
    this.$watch(() => this.shown, () => {
      if (this.reportDimensions.length === 0) {
        this.addReportDim();
      }
    });
    this.$watch(() => this.reportDimensions, () => {
      this.changeValidate();
      // 改动的是同一个对象，无法直接使用vue watch的newValue和oldValue
      if (!isEqual(this.oldReportDimensions, this.reportDimensions)) {
        this.designer.uc.notifyPageletsChange();
        this.saveOldReportDimensions();
      }
    }, {
      deep: true,
      immediate: true
    });
  }
  addReportDim() {
    if (!this.designer.rootPagelet) return;
    if (!this.designer.rootPagelet.reportDimensions) {
      this.$set(this.designer.rootPagelet, 'reportDimensions', []);
    }
    this.designer.rootPagelet.reportDimensions.push({
      id: '',
      name: '',
      public: false,
      value: '',
      dimension: this.dimensions && this.dimensions[0] || ''
    });
    this.designer.uc.notifyPageletsChange();
  }
  render() {
    const h = arguments[0];
    if (!this.shown) return null; // 解脱 computed 依赖
    return h("uc-window", {
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": this.width,
        "title": '编辑上报维度',
        "visible": true
      },
      "on": {
        "close": this.cancel
      }
    }, [h("div", {
      "class": "uc-reportDimsToolbar"
    }, [h("div", {
      "class": "uc-reportDims-list"
    }, [this.reportDimensions.map((param, index) => h(ReportDimItem, {
      "attrs": {
        "validateStatus": this.validateStatus[index],
        "dimensions": [param.dimension].concat(this.dimensions),
        "dimensionDisabled": this.dimensionDisabled
      },
      "on": {
        "delete": async () => {
          if (param.id && !(await this.uc.$confirm('确定要删除吗?可能会影响已有数据上报'))) return;
          this.designer.rootPagelet.reportDimensions.splice(index, 1);
          this.designer.uc.notifyPageletsChange();
        }
      },
      "model": {
        value: param,
        callback: $$v => {
          param = $$v;
        }
      }
    }))]), h("div", {
      "class": "uc-reportDimsToolbar-btns"
    }, [h("button", {
      "class": "uc-button",
      "attrs": {
        "disabled": !this.dimensions.length
      },
      "on": {
        "click": this.addReportDim
      }
    }, ["\u65B0\u589E\u7EF4\u5EA6"]), h("a-tooltip", [h("template", {
      "slot": "title"
    }, ["\u9664\u975E\u6709\u4E0A\u62A5\u6570\u636E\u9519\u4E71\u60C5\u51B5\u9700\u8981\u8C03\u6574\u6620\u5C04\u89C4\u5219\uFF0C\u5176\u4ED6\u60C5\u51B5\u8BF7\u52FF\u4FEE\u6539\uFF01"]), h("button", {
      "class": "uc-button",
      "on": {
        "click": () => {
          this.dimensionDisabled = !this.dimensionDisabled;
        }
      }
    }, [this.dimensionDisabled ? '编辑映射关系' : '锁定映射关系'])])])])]);
  }
  cancel() {
    var _this$respondAndClose;
    (_this$respondAndClose = this.respondAndClose) === null || _this$respondAndClose === void 0 || _this$respondAndClose.call(this, null);
  }
  show(opt) {
    return new Promise(resolve => {
      const position = getPopupPosition({
        anchor: opt.place || document.activeElement,
        container: this.designer.$el,
        width: parseInt(this.width, 10),
        height: 400
      });
      this.left = `${position.x - (this.maxWidth - this.minWidth)}px`;
      this.top = `${position.y}px`;
      this.shown = true;
      this.respondAndClose = ans => {
        resolve(ans);
        this.shown = false;
        this.respondAndClose = undefined;
      };
    });
  }
  clearValidateStatus() {
    this.validateStatus = [];
  }
  validate() {
    this.clearValidateStatus();
    this.reportDimensions.forEach((item, index) => {
      if (!item.id) return;
      // 从当前index开始往后搜看是否重复
      const found = this.reportDimensions.filter(({
        id
      }) => id === item.id);
      if (found.length > 1) {
        this.validateStatus[index] = {
          id: '重复ID'
        };
      }
    });
  }
  saveOldReportDimensions() {
    this.oldReportDimensions = cloneDeep(this.reportDimensions);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], ReportDimsToolbarWidget.prototype, "designer", void 0);
__decorate([Inject(INJECT_UICORE_BUS)], ReportDimsToolbarWidget.prototype, "uc", void 0);
ReportDimsToolbarWidget = __decorate([Component({
  name: 'CreateReportDialog',
  components: {
    UcWindow,
    ExprInput,
    ReportDimItem
  }
})], ReportDimsToolbarWidget);
export default ReportDimsToolbarWidget;
//# sourceMappingURL=CreateReportDialog.js.map
